import { WidgetErrorState } from '../../../shared/constants/widget';

export class NoDataError extends Error {
  readonly errorType: WidgetErrorState;

  constructor(
    message: string = 'No data available for this widget.',
    errorType: WidgetErrorState = WidgetErrorState.NULL,
  ) {
    super(message);
    this.name = 'NoDataError';
    this.errorType = errorType;
  }
}

export class DataFetchError extends Error {
  constructor(message: string = 'Failed to fetch data for this widget.') {
    super(message);
    this.name = 'DataFetchError';
  }
}

export class InvalidFiltersError extends Error {
  constructor(
    message: string = 'The applied filters are invalid for this widget.',
  ) {
    super(message);
    this.name = 'InvalidFiltersError';
  }
}

export class MultipleOrganisationsSelectedError extends Error {
  constructor(
    message: string = 'Multiple organisations selected. Please select a single organisation for this widget.',
  ) {
    super(message);
    this.name = 'MultipleOrganisationsSelectedError';
  }
}
